import { useEffect, useState } from "react";
import { Avatar } from "@chakra-ui/react";
import { useAuthProvider } from "../../../Context/AuthProvider";
import CriancaService from "../../../main/services/CriancaService";
import { useAuth } from "react-oidc-context";

export const FotoUsuario = ({ mobile }) => {
  const auth = useAuth();
  const { user } = useAuthProvider();

  const [foto, setFoto] = useState(null);

  useEffect(() => {
    (async () => {
      const url = user?.foto;
      if (url) {
        await CriancaService.getBlobAvatar(url, auth?.user?.access_token)
          .then((response) => {
            const imageBlob = response.data;
            if (imageBlob) {
              const imageObjectUrl = URL.createObjectURL(imageBlob);
              setFoto(imageObjectUrl);
            }
          })
          .catch((error) => console.error(error));
      }
    })();
  }, [user, auth?.user?.access_token]);

  return foto ? (
    <Avatar alt={user?.name} src={foto} size={mobile ? "md" : "sm"} m={2} />
  ) : (
    <Avatar alt={user?.name} size={mobile ? "md" : "sm"} m={2} />
  );
};
